import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import LoginInterface from '../../api/LoginInterface';
import PlayerInterface from '../../api/PlayerInterface';
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '..';
import { FlowBehaviours } from '../../components/Form/Constants';
import FormId from '../../components/Form/FormId';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import { RewardCenterTabs } from '../RewardCenter/Constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import { propertiesRequestData } from '../../state/slices/properties/properties';
import store from '../../state/store';

var KycConstants = require('../../utils/kyc/Constants');

var CombinedForm = require('../../assets/star/forms/combined.form');
/** @typedef {import('../../api/Constants').SsoUpgradeResponse} SsoUpgradeResponse */

/** @typedef {import('../../api/Constants').KYCCheckResponse} KYCCheckResponse */

/** @typedef {import('../../api/Constants').KYCCheckInfo} KYCCheckInfo */


var STEPS = {
  personalDetails: 0,
  additionalDocuments: 1,
  accountDetails: 2
};
var ALERT_TYPES = {
  error: 'error',
  warning: 'warning',
  success: 'success'
};
var ALERT_TITLES = {
  kycSuccess: getText(TEXT_KEY.ALERT_KYC_SUCCESS),
  kycError: getText(TEXT_KEY.ALERT_KYC_ERROR),
  deDupeError: getText(TEXT_KEY.ALERT_DUP_ERROR)
};
var DOCUMENT_TYPES = {
  DRIVER_LICENCE: 'dl',
  PASSPORT: 'pp'
};

var UpgradeAccountFlow = /*#__PURE__*/function (_Component) {
  _inherits(UpgradeAccountFlow, _Component);

  var _super = _createSuper(UpgradeAccountFlow);

  function UpgradeAccountFlow() {
    var _this;

    _classCallCheck(this, UpgradeAccountFlow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      alertType: '',
      alertTitle: '',
      serverResponse: '',
      layout: CombinedForm,
      inputBehaviour: {},
      userStatus: 'unverified',
      isLoading: false,
      navTo: QueryParamsProxy.findParam(RouteParamConstants.PARAM_NAVIGATE_TO, null),
      step: STEPS.personalDetails
    };

    _this._handleStepChange = function () {
      var setFormInfo = _this.props.setFormInfo;
      var step = _this.state.step;

      if (step === STEPS.personalDetails) {
        setFormInfo({
          key: FormId.COUNTRY,
          value: 'AU',
          validated: true
        });
        Logger.sendEvent(EVENT_TYPES.KYC_BASIC_CHECK_INIT);
      } else if (step === STEPS.additionalDocuments) {
        setFormInfo({
          key: FormId.DOCUMENT_TYPE,
          value: 'dl',
          validated: true
        });
        setFormInfo({
          key: FormId.STATE,
          value: 'dl_nsw',
          validated: true
        });
        Logger.sendEvent(EVENT_TYPES.KYC_DOCUMENT_CHECK_INIT);
      }
    };

    _this._layoutChangeHandler = function (changeType, newValue) {
      var newLayout = _objectSpread({}, _this.state.layout);

      var personalDetailsStep = STEPS.personalDetails;
      var additionalDocumentStep = STEPS.additionalDocuments;
      var personalDetailsStepLength = 12;

      switch (changeType) {
        case 'toggleAutocomplete':
          newLayout.steps[personalDetailsStep].formInputList[10].options = KycConstants.AUSTRALIAN_STATES;
          newLayout.steps[personalDetailsStep].formInputList[5].hasAutocompleteToggle = true;

          if (!newLayout.steps[personalDetailsStep].formInputList[11].hide) {
            newLayout.steps[personalDetailsStep].formInputList[10].hide = false;
          }

          for (var i = 4; i <= personalDetailsStepLength; i++) {
            newLayout.steps[personalDetailsStep].formInputList[i].hide = !newLayout.steps[personalDetailsStep].formInputList[i].hide;
          }

          newLayout.steps[personalDetailsStep].formInputList[11].hide = true;
          break;

        case 'autocompleteOff':
          newLayout.steps[personalDetailsStep].formInputList[5].hasAutocompleteToggle = false;
          newLayout.steps[personalDetailsStep].formInputList[4].hide = true;

          for (var _i = 5; _i <= personalDetailsStepLength; _i++) {
            newLayout.steps[personalDetailsStep].formInputList[_i].hide = false;
          }

          newLayout.steps[personalDetailsStep].formInputList[10].hide = true;
          newLayout.steps[personalDetailsStep].formInputList[11].hide = false;
          break;

        case 'autocompleteOff_NZ':
          newLayout.steps[personalDetailsStep].formInputList[10].options = KycConstants.NEW_ZEALAND_REGIONS;
          newLayout.steps[personalDetailsStep].formInputList[5].hasAutocompleteToggle = false;
          newLayout.steps[personalDetailsStep].formInputList[4].hide = true;

          for (var _i2 = 5; _i2 <= personalDetailsStepLength; _i2++) {
            newLayout.steps[personalDetailsStep].formInputList[_i2].hide = false;
          }

          newLayout.steps[personalDetailsStep].formInputList[11].hide = true;
          break;

        case 'toggleDocumentStateCountry':
          if (newValue === DOCUMENT_TYPES.DRIVER_LICENCE) {
            newLayout.steps[additionalDocumentStep].formInputList[5].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[6].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[7].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[8].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[9].hide = false;
          } else if (newValue === DOCUMENT_TYPES.PASSPORT) {
            newLayout.steps[additionalDocumentStep].formInputList[5].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[6].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[7].hide = false;
            newLayout.steps[additionalDocumentStep].formInputList[8].hide = true;
            newLayout.steps[additionalDocumentStep].formInputList[9].hide = true;
          }

          break;
      }

      _this.setState({
        layout: newLayout
      });
    };

    _this.handleCountryChange = function () {
      var value = _this.props.formInfo.country.value;

      if (value === 'AU') {
        _this._layoutChangeHandler('toggleAutocomplete');
      } else if (value === 'NZ') {
        _this._layoutChangeHandler('autocompleteOff_NZ');
      } else {
        _this._layoutChangeHandler('autocompleteOff');
      }
    };

    _this._submitHandler = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var deDupePass, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context.next = 3;
              return _this._deDupeCheck();

            case 3:
              deDupePass = _context.sent;

              if (deDupePass) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              if (!(_this.state.step === STEPS.accountDetails)) {
                _context.next = 10;
                break;
              }

              _this._upgradeGuest();

              _context.next = 15;
              break;

            case 10:
              _context.next = 12;
              return _this._knowYourCustomerCheck();

            case 12:
              response = _context.sent;

              if (response.success) {
                _this._handleKYCSuccess(response);
              } else {
                _this._handleKYCFailure(response);
              }

              if (response.inprogress) {
                _this.setState({
                  step: STEPS.additionalDocuments
                });
              }

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this._deDupeCheck = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, _this$props$formInfo, firstName, lastName, dateOfBirth, email, handleStarLogin, step, deDupeResponse, result, _result;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, _this$props$formInfo = _this$props.formInfo, firstName = _this$props$formInfo.firstName, lastName = _this$props$formInfo.lastName, dateOfBirth = _this$props$formInfo.dateOfBirth, email = _this$props$formInfo.email, handleStarLogin = _this$props.handleStarLogin;
              step = _this.state.step;

              if (!(step === STEPS.personalDetails)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 5;
              return PlayerInterface.deDupeCheck({
                type: 'dup',
                firstname: firstName.value,
                lastname: lastName.value,
                dob: dateOfBirth.value
              });

            case 5:
              result = _context2.sent;
              deDupeResponse = result[0];
              _context2.next = 14;
              break;

            case 9:
              if (!(step === STEPS.accountDetails)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 12;
              return PlayerInterface.deDupeCheck({
                type: 'email',
                email: email.value
              });

            case 12:
              _result = _context2.sent;
              deDupeResponse = _result[0];

            case 14:
              if (!(deDupeResponse && !deDupeResponse.success)) {
                _context2.next = 17;
                break;
              }

              if (deDupeResponse.error_code === 'bbe3api_sic_dup_yes') {
                _this.setState({
                  alertType: ALERT_TYPES.warning,
                  alertTitle: ALERT_TITLES.deDupeError,
                  serverResponse: getText(TEXT_KEY.REDIRECTING_TO_STAR_CLUB),
                  isLoading: false
                });

                setTimeout(handleStarLogin, 4000);
              } else {
                _this.setState({
                  alertType: ALERT_TYPES.error,
                  alertTitle: '',
                  serverResponse: deDupeResponse.error,
                  isLoading: false
                });
              }

              return _context2.abrupt("return", false);

            case 17:
              return _context2.abrupt("return", true);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    _this._knowYourCustomerCheck = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var kycCheckResponse, _this$props$formInfo2, country, address, firstName, lastName, dateOfBirth, unitNumber, streetNumber, streetName, streetType, city, state, state_input, postalCode, stateValue, kycCheckInfo, addressPayload, addressComponentPayload, _iterator, _step, addressComponent, value, component, componentName, _this$props$formInfo3, documentNumber, documentType, middleName, _state, passportCountry, driverLicenceNumber, driverLicenceCardNumber, stateKey, rawResponse;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this.props.formInfo) {
                _context3.next = 22;
                break;
              }

              _this$props$formInfo2 = _this.props.formInfo, country = _this$props$formInfo2.country, address = _this$props$formInfo2.address, firstName = _this$props$formInfo2.firstName, lastName = _this$props$formInfo2.lastName, dateOfBirth = _this$props$formInfo2.dateOfBirth, unitNumber = _this$props$formInfo2.unitNumber, streetNumber = _this$props$formInfo2.streetNumber, streetName = _this$props$formInfo2.streetName, streetType = _this$props$formInfo2.streetType, city = _this$props$formInfo2.city, state = _this$props$formInfo2.state, state_input = _this$props$formInfo2.state_input, postalCode = _this$props$formInfo2.postalCode;
              stateValue = state.value;

              if (country.value !== 'AU' || country.value !== 'NZ') {
                stateValue = state_input.value;
              }

              kycCheckInfo = {
                issuecountry: country.value,
                dob: dateOfBirth.value,
                firstname: firstName.value,
                lastname: lastName.value
              };
              addressPayload = address.value && Object.keys(address.value).length > 0 ? address.value : {
                components: [{
                  streetNumber: streetNumber.value
                }, {
                  street: streetName.value
                }, {
                  locality: city.value
                }, {
                  province: stateValue
                }, {
                  provinceCode: stateValue
                }, {
                  postalCode: postalCode.value
                }, {
                  country: country.value
                }, {
                  countryISO: country.value
                }, {
                  subBuilding: unitNumber.value
                }, {
                  streetType: streetType.value
                }, {
                  manual: true
                }]
              };
              addressComponentPayload = {};
              _iterator = _createForOfIteratorHelper(addressPayload.components);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  addressComponent = _step.value;
                  value = Object.values(addressComponent)[0];
                  component = Object.keys(addressComponent)[0];
                  componentName = component.charAt(component.length - 1) === '1' ? component.slice(0, -1) : component;
                  addressComponentPayload[componentName] = value;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              kycCheckInfo.addresscomponents = addressComponentPayload;

              if (_this.props.formInfo.documentType) {
                _this$props$formInfo3 = _this.props.formInfo, documentNumber = _this$props$formInfo3.documentNumber, documentType = _this$props$formInfo3.documentType, middleName = _this$props$formInfo3.middleName, _state = _this$props$formInfo3.state, passportCountry = _this$props$formInfo3.passportCountry, driverLicenceNumber = _this$props$formInfo3.driverLicenceNumber, driverLicenceCardNumber = _this$props$formInfo3.driverLicenceCardNumber;

                if (documentType.value === DOCUMENT_TYPES.DRIVER_LICENCE) {
                  Object.assign(kycCheckInfo, {
                    middlename: middleName.value,
                    doctype: documentType.value,
                    licence_number: driverLicenceNumber.value,
                    licence_card_number: driverLicenceCardNumber.value
                  });
                  stateKey = _state.value;
                  kycCheckInfo.issuestate = KycConstants.DRIVER_LICENSE_STATE_PAYLOAD[stateKey].value;
                } else if (documentType.value === DOCUMENT_TYPES.PASSPORT) {
                  Object.assign(kycCheckInfo, {
                    middlename: middleName.value,
                    doctype: documentType.value,
                    docnum: documentNumber.value
                  });
                  kycCheckInfo.issuecountry = passportCountry.value;
                }
              }

              _context3.prev = 11;
              _context3.next = 14;
              return PlayerInterface.knowYourCustomer(kycCheckInfo);

            case 14:
              rawResponse = _context3.sent;
              kycCheckResponse = rawResponse[0];

              if (!kycCheckResponse.success) {
                _this.setState({
                  alertType: ALERT_TYPES.error,
                  alertTitle: ALERT_TITLES.kycError,
                  serverResponse: kycCheckResponse && kycCheckResponse.error,
                  isLoading: false
                });
              } else {
                // Logging KYC Complete events here before the step state changes so
                // we are able to determine what step KYC completed on.
                if (_this.state.step === STEPS.accountDetails) {
                  Logger.sendEvent(EVENT_TYPES.KYC_BASIC_CHECK_COMPLETED);
                } else if (_this.state.step === STEPS.additionalDocuments) {
                  Logger.sendEvent(EVENT_TYPES.KYC_DOCUMENT_CHECK_COMPLETED);
                }

                _this.setState({
                  step: STEPS.accountDetails,
                  alertType: ALERT_TYPES.success,
                  alertTitle: ALERT_TITLES.kycSuccess,
                  serverResponse: kycCheckResponse && kycCheckResponse.msg,
                  isLoading: false
                });
              }

              _context3.next = 22;
              break;

            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3["catch"](11);

              _this.setState({
                isLoading: false,
                serverResponse: _context3.t0 && _context3.t0.error,
                alertType: ALERT_TYPES.error,
                alertTitle: ''
              });

            case 22:
              return _context3.abrupt("return", kycCheckResponse);

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[11, 19]]);
    }));
    _this._upgradeGuest = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var upgradeUserResponse, _this$props$formInfo4, email, password, firstName, lastName, dateOfBirth, userInfo, rawResponse;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this.props.formInfo) {
                _context4.next = 14;
                break;
              }

              _this$props$formInfo4 = _this.props.formInfo, email = _this$props$formInfo4.email, password = _this$props$formInfo4.password, firstName = _this$props$formInfo4.firstName, lastName = _this$props$formInfo4.lastName, dateOfBirth = _this$props$formInfo4.dateOfBirth;
              userInfo = {
                firstname: firstName.value,
                lastname: lastName.value,
                dob: dateOfBirth.value
              };
              _context4.prev = 3;
              _context4.next = 6;
              return LoginInterface.ssoUpgrade(_this.state.userStatus, email.value, password.value, userInfo);

            case 6:
              rawResponse = _context4.sent;
              upgradeUserResponse = rawResponse[0];

              if (!upgradeUserResponse.success) {
                _this.setState({
                  alertType: ALERT_TYPES.error,
                  alertTitle: '',
                  isLoading: false,
                  serverResponse: upgradeUserResponse && upgradeUserResponse.error
                });
              } else {
                _this._handleUpgradeSuccess(upgradeUserResponse);
              }

              _context4.next = 14;
              break;

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](3);

              _this.setState({
                alertType: ALERT_TYPES.error,
                alertTitle: '',
                isLoading: false,
                serverResponse: _context4.t0 && _context4.t0.error
              });

            case 14:
              return _context4.abrupt("return", upgradeUserResponse);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 11]]);
    }));

    _this._handleUpgradeSuccess = function (upgradeUserResponse) {
      _this.props.addNotif({
        title: getText(TEXT_KEY.SUCCESS_NOTIFICATION_TITLE),
        message: "".concat(getText(TEXT_KEY.SUCCESS_NOTIFICATION_MESSAGE)).concat(upgradeUserResponse.casinoId, ".")
      });

      _this.props.setCasinoIdStatus(upgradeUserResponse.casinoIdStatus);

      _this.props.setPlayerId(upgradeUserResponse.playerId);

      _this.props.setCasinoId(upgradeUserResponse.casinoId);

      _this.props.setCurrentMemberLevel(upgradeUserResponse.currentMemberLevel);

      _this.props.isAccountLinked('yes');

      Logger.sendEvent(EVENT_TYPES.REGISTRATION_COMPLETE, {
        type: 'email'
      });
      store.dispatch(propertiesRequestData());

      _this._finishUpgradeFlow();
    };

    _this._handleKYCSuccess = function () {
      var _this$props2 = _this.props,
          _this$props2$formInfo = _this$props2.formInfo,
          firstName = _this$props2$formInfo.firstName,
          lastName = _this$props2$formInfo.lastName,
          dateOfBirth = _this$props2$formInfo.dateOfBirth,
          setKYCStatus = _this$props2.setKYCStatus;
      var userInfo = {
        firstname: firstName.value,
        lastname: lastName.value,
        dob: dateOfBirth.value
      };
      setKYCStatus({
        isKYCDone: true,
        KYCResult: KycConstants.KYC_STATUS.PASS,
        KYCInfo: userInfo
      });

      _this.setState({
        step: STEPS.accountDetails
      });
    };

    _this._handleKYCFailure = function (kycCheckResponse) {
      if (kycCheckResponse.error_code === 'Kyc_fail') {
        var _QueryParamsProxy$set;

        _this.props.setKYCStatus({
          isKYCDone: true,
          KYCResult: KycConstants.KYC_STATUS.FAILED
        });

        Logger.sendEvent(EVENT_TYPES.KYC_LOCKED_OUT);
        QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_MODAL, Screens.KYCLockout), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_NAVIGATE_TO, undefined), _defineProperty(_QueryParamsProxy$set, RouteParamConstants.PARAM_UPGRADE_TYPE, undefined), _QueryParamsProxy$set));
      } else if (_this.state.step === STEPS.personalDetails) {
        Logger.sendEvent(EVENT_TYPES.KYC_BASIC_CHECK_FAILED);
      } else if (_this.state.step === STEPS.additionalDocuments) {
        Logger.sendEvent(EVENT_TYPES.KYC_DOCUMENT_CHECK_FAILED);
      }
    };

    _this._finishUpgradeFlow = function () {
      // Navigate to next screen if applicable, if not navigate home
      if (_this.state.navTo) {
        if (_this.state.navTo === Screens.RewardCenter) {
          _this.props.setActiveTab(RewardCenterTabs.HOME);

          QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.RewardCenter));
        } else {
          var _QueryParamsProxy$set3;

          // Used on mobile to mount PurchaseFlow component in LobbyOverlay
          // the delay is there to prevent the component be displayed before the KYC modal is hidden
          setTimeout(function () {
            _this.props.initiatePurchase();
          }, 2000);
          QueryParamsProxy.setQueryParams((_QueryParamsProxy$set3 = {}, _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_MODAL, Utils.getPlatform() === 'web' ? _this.state.navTo : undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_NAVIGATE_TO, undefined), _defineProperty(_QueryParamsProxy$set3, RouteParamConstants.PARAM_UPGRADE_TYPE, undefined), _QueryParamsProxy$set3));
        }
      } else {
        var _QueryParamsProxy$set4;

        QueryParamsProxy.setQueryParams((_QueryParamsProxy$set4 = {}, _defineProperty(_QueryParamsProxy$set4, RouteParamConstants.PARAM_MODAL, undefined), _defineProperty(_QueryParamsProxy$set4, RouteParamConstants.PARAM_UPGRADE_TYPE, undefined), _QueryParamsProxy$set4));
        QueryParamsProxy.navigate(_this.props.navigation, Screens.Home);
      }
    };

    return _this;
  }

  _createClass(UpgradeAccountFlow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._handleStepChange();

      var _this$props3 = this.props,
          isKYCDone = _this$props3.isKYCDone,
          KYCResult = _this$props3.KYCResult,
          KYCInfo = _this$props3.KYCInfo,
          setFormInfo = _this$props3.setFormInfo;

      if (KYCInfo && isKYCDone && KYCResult === KycConstants.KYC_STATUS.PASS) {
        this.setState({
          step: STEPS.accountDetails
        });
        setFormInfo({
          key: FormId.FIRSTNAME,
          value: KYCInfo.firstname,
          validated: true
        });
        setFormInfo({
          key: FormId.LASTNAME,
          value: KYCInfo.lastname,
          validated: true
        });
        setFormInfo({
          key: FormId.DATE_OF_BIRTH,
          value: KYCInfo.dob,
          validated: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.step !== this.state.step) {
        this._handleStepChange();
      }

      if (prevProps.formInfo.documentType && prevProps.formInfo.documentType.value !== this.props.formInfo.documentType.value) {
        this._layoutChangeHandler('toggleDocumentStateCountry', this.props.formInfo.documentType.value);
      }

      if (prevProps.formInfo.country && prevProps.formInfo.country.value !== this.props.formInfo.country.value) {
        this.handleCountryChange();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var newLayout = _objectSpread({}, this.state.layout);

      var additionalDocumentStep = STEPS.additionalDocuments;

      if (newLayout) {
        newLayout.steps[additionalDocumentStep].formInputList[5].hide = false;
        newLayout.steps[additionalDocumentStep].formInputList[6].hide = true;
        newLayout.steps[additionalDocumentStep].formInputList[7].hide = true;
        newLayout.steps[additionalDocumentStep].formInputList[8].hide = false;
        newLayout.steps[additionalDocumentStep].formInputList[9].hide = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _flowBehaviour;

      return this.props.render({
        layout: this.state.layout,
        submitHandle: this._submitHandler,
        alertType: this.state.alertType,
        alertTitle: this.state.alertTitle,
        serverResponse: this.state.serverResponse,
        isLoading: this.state.isLoading,
        layoutChangeHandler: this._layoutChangeHandler,
        step: this.state.step,
        flowBehaviour: (_flowBehaviour = {}, _defineProperty(_flowBehaviour, STEPS.personalDetails, FlowBehaviours.SUBMIT), _defineProperty(_flowBehaviour, STEPS.additionalDocuments, FlowBehaviours.SUBMIT), _defineProperty(_flowBehaviour, STEPS.accountDetails, FlowBehaviours.SUBMIT), _flowBehaviour)
      });
    }
  }]);

  return UpgradeAccountFlow;
}(Component);

export { UpgradeAccountFlow as default };